import React from 'react';
import { motion } from 'framer-motion';
interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
  tone?: 'forest' | 'sand';
  className?: string;
}
export function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'left',
  tone = 'forest',
  className = ''
}: SectionHeadingProps) {
  const alignCls = align === 'center' ? 'text-center mx-auto items-center' : 'text-left items-start';
  const chipCls = tone === 'forest' ? 'bg-sage-100 text-forest-700' : 'bg-sand-100 text-sand-500';
  return <motion.div initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.6,
    ease: [0.22, 1, 0.36, 1]
  }} className={`flex flex-col gap-4 max-w-2xl ${alignCls} ${className}`} data-id="element-799" data-mp="d8btw2oqlmzd">
      {eyebrow && <span className={`inline-flex items-center gap-2 px-3 py-1 rounded-full text-[11px] font-medium uppercase tracking-[0.14em] ${chipCls}`} data-id="element-800" data-mp="1e0atii01w0pb">
          {eyebrow}
        </span>}
      <h2 className="font-display text-3xl md:text-4xl lg:text-[2.75rem] leading-[1.1] tracking-tight text-ink-900" data-id="element-801" data-mp="150w4zo3g207g">
        {title}
      </h2>
      {description && <p className="text-ink-700 text-base md:text-lg leading-relaxed max-w-xl" data-id="element-802" data-mp="1wracn2kv6gao">
          {description}
        </p>}
    </motion.div>;
}